import React from "react";
import {
  IconCog,
  IconFontSizeLarge,
  IconFontSizeSmall,
  IconLightModeBright,
  IconLightModeDark,
  IconFootnotesOffWhite,
  IconFootnotesOnWhite,
  IconFootnotesOff,
  IconVerseNumbersOff,
  IconVerseNumbersOnWhite,
  IconVerseNumbersOffWhite,
  IconVerseNumbersOn,
  FlyoutMenu,
  useUserSettings
} from "@americanbible/uikit";

export const ViewSettingsMenu = ({ anchor, open, iconColor }) => {
  const {
    fontSize,
    darkMode,
    showFootnotes,
    showVerseNumbers,
    setDarkMode,
    setFontSize,
    setShowVerseNumbers,
    setShowFootnotes
  } = useUserSettings();

  return (
    <FlyoutMenu
      anchor={anchor}
      icon={() => <IconCog color={iconColor} />}
      open={open}
      iconList={[
        {
          icon: IconFontSizeLarge,
          handler: () => setFontSize(fontSize + 2),
          key: "font-larger"
        },
        {
          icon: IconFontSizeSmall,
          handler: () => setFontSize(fontSize - 2),
          key: "font-smaller"
        },
        {
          icon: darkMode ? IconLightModeBright : IconLightModeDark,
          handler: () => setDarkMode(!darkMode),
          key: "dark-mode-toggle"
        },
        {
          icon: darkMode
            ? showFootnotes
              ? IconFootnotesOffWhite
              : IconFootnotesOnWhite
            : showFootnotes
            ? IconFootnotesOff
            : IconVerseNumbersOff,
          handler: () => setShowFootnotes(!showFootnotes),
          key: "footnotes-toggle"
        },
        {
          icon: darkMode
            ? showVerseNumbers
              ? IconVerseNumbersOnWhite
              : IconVerseNumbersOffWhite
            : showVerseNumbers
            ? IconVerseNumbersOn
            : IconVerseNumbersOff,
          handler: () => setShowVerseNumbers(!showVerseNumbers),
          key: "verser-number-toggle"
        }
      ]}
    />
  );
};
